import { Modal } from '@pankod/refine-antd';

import type { ModalProps } from '@pankod/refine-antd';

interface ModalTypes {
  modalProps: ModalProps;
  onClose: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  message: string;
}

const MessageModal = ({ onClose, modalProps, message }: ModalTypes) => {
  return (
    <Modal onOk={onClose} {...modalProps}>
      {message}
    </Modal>
  );
};

export default MessageModal;
